import React from 'react'
// import { StaticQuery, graphql, Link } from 'gatsby'
import { Link } from 'gatsby'
import styled from 'styled-components'
// import Img from 'gatsby-image'
import PhotoContainer from '../../../styles/main-photo-container-styles';
import PhotoHeader from '../../../styles/main-photo-styles';


class HotelsBlock extends React.Component {
    render() {
      // const { data } = this.props
      return(
        <MainContainer>
          <h2>Find Your Hotel or Hostel</h2>
          <p>The number of tourists that visited Moscow in <strong>2018</strong> has increased to more than <strong>23 million</strong> people. Currently there are close to <strong>1200 hotels</strong> and about <strong>350 hostels</strong> in the city. 
              Most tourists prefer to stay at 3 and 4-star hotels. There are more than <strong>6000</strong> new hotel rooms planned to be open in Moscow by <strong>2023</strong> to meet the increasing demand both from local and foreign travellers.</p>
          <PhotoContainer>
            <Link to={`/hotels/`}> 
                <picture><img src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559149701/Landing-MAIN/moscow-main-hotels-960.jpg" alt="moscow"/></picture>
            </Link>

            <PhotoHeader>
                <Link to={`/hotels/`}>
                  <span>Top Hotels To Stay</span>
                    <br></br>
                  <span>in Moscow in 2019</span>
                </Link>
            </PhotoHeader>
          </PhotoContainer>
   
          </MainContainer>
      )
    }
}

const MainContainer = styled.div`
`;


export default HotelsBlock

// const mainPageHotels = graphql`
//   query mainPageHotels {
//     image1: file(relativePath: { eq: "main/moscow-main-hotels-960.jpg" }) {
//       ...mainPageHotelsImage
//     }
//     # image2: file(relativePath: { eq: "banners/vanilia.jpg" }) {
//     #   ...squareImage
//     # }
// }
// `

// export const mainPageHotelsImage = graphql`
//   fragment mainPageHotelsImage on File {
//     childImageSharp {
//       fluid(maxWidth: 960, maxHeight: 400, quality: 100 ) {
//         ...GatsbyImageSharpFluid
//       }
//     }
//   }
// `